<script lang="ts">
	import { noteCtaClick } from '$lib/stores/auth.svelte';

	interface Props {
		variant?: 'inline' | 'closing';
		heading?: string;
		body?: string;
		cta?: string;
		href?: string;
		/** Identifiant court du CTA, joint à l'événement d'inscription (ex. « edt-cp-inline »). */
		source?: string;
	}

	let {
		variant = 'inline',
		heading = 'Et si l\'IA écrivait le premier jet ?',
		body = "Avec Fiche Séquence, vous renseignez le niveau, l'objectif et le domaine. L'IA génère une fiche complète, alignée sur les programmes officiels. Vous gardez la main pour personnaliser.",
		cta = "Créer mon compte gratuit",
		href = '/signup',
		source = undefined
	}: Props = $props();
</script>

{#if variant === 'inline'}
	<aside class="not-prose my-10 rounded border border-marge/20 bg-marge-pale p-6 md:p-8">
		<p class="font-display text-xl font-titre leading-tight text-ink md:text-2xl">{heading}</p>
		<p class="mt-3 max-w-2xl text-base leading-relaxed text-ink">{body}</p>
		<a
			href={href}
			onclick={() => noteCtaClick(source)}
			class="mt-5 inline-flex items-center justify-center btn-relief px-5 py-2.5 text-sm font-semibold"
		>
			{cta}
		</a>
		<p class="mt-3 text-xs text-ash">Compte gratuit, sans carte bancaire.</p>
	</aside>
{:else}
	<aside class="not-prose mt-12 border-t border-mist bg-paper py-12 md:py-16">
		<div class="mx-auto max-w-2xl text-center">
			<p class="font-display text-2xl font-titre leading-tight text-ink md:text-3xl">{heading}</p>
			<p class="mt-4 text-base leading-relaxed text-ash">{body}</p>
			<a
				href={href}
				onclick={() => noteCtaClick(source)}
				class="mt-8 inline-flex items-center justify-center btn-relief px-6 py-3 text-base font-semibold"
			>
				{cta}
			</a>
			<p class="mt-4 text-sm text-ash">Compte gratuit · Sans carte bancaire · Sans engagement.</p>
		</div>
	</aside>
{/if}
